import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';

import { IAccordion } from 'source/NFR.types';

interface AccordionContainerProps {
  accordion: IAccordion;
  buttonText?: string;
}

const AccordionContainer: React.FC<React.PropsWithChildren<AccordionContainerProps>> = ({
  accordion,
  buttonText,
  children
}) => {
  return (
    <div className="accordion-container">
      <Accordion {...accordion}>
        {({ Button, Collapse, isOpen }) => (
          <>
            {buttonText && (
              <Button className="accordion-container--button">
                <h2 className="accordion-container--button-text">{buttonText}</h2>

                <Icon
                  className={cn('accordion-container--icon', {
                    'accordion-container--icon--is-open': isOpen
                  })}
                  name="small-arrow-down"
                  fill={true}
                />
              </Button>
            )}
            <Collapse>
              <div className="accordion-container--content">{children}</div>
            </Collapse>
          </>
        )}
      </Accordion>
    </div>
  );
};

AccordionContainer.displayName = 'AccordionContainer';

export default AccordionContainer;
